module.exports = __webpack_public_path__ + "7e6ae0e3d6abf7503b487d71c6148bcc.svg";